import Typography from "@/components/ui/typography";
import { InfoIcon } from "lucide-react";
import type { ReactNode } from "react";

type AddBusinessDetailsPromptProps = {
	children: ReactNode;
	/** Use inside nested layouts (e.g. settings) so outer page padding is not applied. */
	embedInParent?: boolean;
};

/** Shared empty-state for flows that require guest business details first; pass the primary action as `children` (e.g. Button or Button+Link). */
export function AddBusinessDetailsPrompt({
	children,
	embedInParent = false,
}: AddBusinessDetailsPromptProps) {
	const card = (
		<div className="mx-auto w-full max-w-lg rounded-2xl border border-border bg-white p-6 text-center shadow-sm md:p-8">
			<div className="flex flex-col items-center gap-4">
				<div
					className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-600"
					aria-hidden
				>
					<InfoIcon className="h-7 w-7 shrink-0" strokeWidth={1.75} />
				</div>
				<Typography variant="h2" color="primary" className="text-balance">
					In order to use Kashu, you must first add your business details.
				</Typography>
				<Typography
					variant="p"
					color="primary-light"
					className="max-w-md text-balance"
				>
					Add your business name, address, and contact number when you are
					ready.
				</Typography>
				<div className="mt-1 w-full max-w-sm">{children}</div>
			</div>
		</div>
	);

	if (embedInParent) {
		return card;
	}

	return <div className="max-w-container mx-auto px-6 py-10">{card}</div>;
}
